export default function TopBar() {
  return (
    <div className="bg-secondary-950 text-background-50 relative overflow-hidden">
      <div className="absolute inset-0 texture-dots-light opacity-30" />
      <div className="relative w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between py-2 text-xs">
          <div className="flex items-center gap-4 md:gap-6">
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-time-line" />
              </span>
              <span className="font-medium">Atención 24 horas</span>
            </span>
            <span className="hidden md:flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-map-pin-line" />
              </span>
              <span className="text-background-200">Junín 1152, Tarija</span>
            </span>
          </div>
          <div className="flex items-center gap-4 md:gap-6">
            <a
              href="tel:+59177173439"
              className="flex items-center gap-1.5 hover:text-accent-500 transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line" />
              </span>
              <span className="font-semibold">77173439</span>
            </a>
            <a
              href="https://wa.me/59177173439"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 hover:text-accent-500 transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line" />
              </span>
              <span className="hidden md:inline">WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}